<template>
  <button type="button" class="bg-white text-sm rounded-md font-medium  focus:outline-none focus:ring-2 focus:ring-offset-2"
          :class="colors[color]">
    <slot>btn text</slot>
  </button>
</template>

<script>
export default {
  name: "UiButtonInline",
  props: {
    color: {default: 'primary'}
  },
  data() {
    return {
      colors: {
        'primary': 'text-primary-600 hover:text-primary-500 focus:ring-primary-500',
        'red': 'text-red-600 hover:text-red-500 focus:ring-red-500',
      }
    }
  }
}
</script>

<style scoped>

</style>